import { Injectable } from '@angular/core';
import {
    ProductSearchPage,
    OccProductSearchPageNormalizer,
} from '@spartacus/core';
import { Converter } from '@spartacus/core';

@Injectable()
export class CustomProductSearchPageNormalizer
    extends OccProductSearchPageNormalizer
    implements Converter<any, ProductSearchPage>
{
    /**
     * The (current) backend returns facets with values that do not contribute
     * to the facet navigation much, as the number in the result list will not get
     * behavior, see https://jira.hybris.com/browse/CS-427.
     *
     * As long as this is not in place, we manually filter the facet from the list;
     * any facet that does not have a count < the total results will be dropped from
     * the facets.
     */
    protected override normalizeUselessFacets(target: ProductSearchPage): void {
        if (target.facets) {
            target.facets = target.facets.filter((facet) => {
                return (
                    !target.pagination ||
                    !target.pagination.totalResults ||
                    ((!facet.hasOwnProperty('visible') || facet.visible) &&
                        facet.values &&
                        facet.values.find((value) => {
                            return (
                                value.selected ||
                                (value.count ?? 0) <= (target.pagination?.totalResults ?? 0)
                            );
                        }))
                );
            });
        }
    }
}
